
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Editable from '@/mixins/Editable';
import Notification from '@/mixins/Notification';
import StackedForm from '@/mixins/StackedForm';
import VWrapper from '@/components/shared/VWrapper.vue';
import { namespace } from 'vuex-class';
import EditReleasesLoader from '@/components/releases/EditReleasesLoader.vue';
import ReleasesForm from '@/components/releases/ReleasesForm.vue';
import { Release as ReleaseModel } from '@/interfaces/models/Release';
import { scrollToFailedField } from '@/util/helper';

const releases = namespace('releases');

@Component({
  components: { VWrapper, ReleasesForm, EditReleasesLoader },
})
export default class EditRelease extends mixins(Editable, Notification, StackedForm) {
  @releases.Action('store') public store!: any;
  @releases.Action('show') public show!: any;
  @releases.Action('update') public update!: any;
  @releases.State('active') public active!: ReleaseModel;

  public $refs!: {
    form: InstanceType<typeof ReleasesForm> & { getData: () => any; validate: () => Promise<boolean | boolean[]> };
  };

  get release() {
    if (this.editing && this.active) {
      return this.active;
    }

    return null;
  }

  get title() {
    return this.editing ? 'releases.edit' : 'releases.create';
  }

  public save() {
    this.$refs.form.validate().then(async (res: boolean | boolean[]) => {
      this.$startLoading('release.saving');
      if (this.isValid(res)) {
        if (this.editing) {
          await this.update({ ...this.$refs.form.getData(), id: this.release!._id });
        } else {
          await this.store(this.$refs.form.getData());
        }

        this.$router.push({ name: 'releases.index', query: { ...this.$route.query } });
      } else {
        scrollToFailedField();

        this.notifyError('notification.form');
      }
      this.$stopLoading('release.saving');
    });
  }

  public async mounted() {
    if (this.editing) {
      this.$startLoading('release');
      await this.show({ id: this.id });
    }

    if (this.editing && !this.active) {
      this.$router.push({ name: 'releases.index', query: { ...this.$route.query } });
    }
    this.$stopLoading('release');
  }
}
